export enum SituacaoPessoaEnum {

  ATIVA = "Ativa",
  BAIXADA = "Baixada",
  BLOQUEADA = "Bloqueada",
  PARALISADA = "Paralisada"
}
